/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ArticleSelector_viewer$ref = any;
export type ConfigurableBlockType = "embed" | "listNews" | "live" | "news" | "video" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ConfigurableBlockEdit_viewer$ref: FragmentReference;
export type ConfigurableBlockEdit_viewer = {|
  +id: string,
  +configurableBlock: ?{|
    +id: string,
    +type: ConfigurableBlockType,
    +slug: ?string,
    +active: ?boolean,
    +config: ?any,
  |},
  +$fragmentRefs: ArticleSelector_viewer$ref,
  +$refType: ConfigurableBlockEdit_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ConfigurableBlockEdit_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "id",
      "type": "ID!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ArticleSelector_viewer",
      "args": null
    },
    v0,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "configurableBlock",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id",
          "type": "ID"
        }
      ],
      "concreteType": "ConfigurableBlock",
      "plural": false,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "slug",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "active",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "config",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '9ddcdb71ae87116b870643b7cb0b45ec';
module.exports = node;



// WEBPACK FOOTER //
// src/components/configurable-blocks/__generated__/ConfigurableBlockEdit_viewer.graphql.js